import { render, staticRenderFns } from "./MigrationNotification.vue?vue&type=template&id=3d0ba7a5&scoped=true"
import script from "./MigrationNotification.vue?vue&type=script&lang=js"
export * from "./MigrationNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ba7a5",
  null
  
)

export default component.exports